import React from "react";

const Footer = () => {
  return (
    <div className="bg-[#2d0249cd] flex justify-center py-10 px-4 md:px-10">
      <h1 className="font-medium text-lg">
        © 2024 All Rights Reserved | Designed by{" "}
        <span className="text-pink-600">Vamsi Ankabattula</span>
      </h1>
    </div>
  );
};

export default Footer;
